import { MessagingHelper } from "../helpers/MessagingHelper";
import { DigitalSignatureDTO } from "../models/Assistance/DigitalSignatureDTO";
import { ResetPasswordDTO } from "../models/ResetPasswordDTO";
import { PasswordUpdateDTO } from "../models/User/PasswordUpdateDTO";
import { UserDetailDTO } from "../models/User/UserDetailDTO";
import { UserUpdateDTO } from "../models/User/UserUpdateDTO";
import { APIService } from "./APIService";

export class UserService {

    async GetById(userId: string): Promise<MessagingHelper<UserDetailDTO | null>> {
        try {
            var response = await APIService.Axios().get(`${APIService.GetURL()}/user/GetUserById/${userId}`, {
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + APIService.GetToken()
                }
            });
            return response.data;
        } catch (error) {
            return new MessagingHelper<UserDetailDTO | null>(false, "Erro ao obter a informação do utilizador", null);
        };
    }

    async UpdatePassword(userId: string, updatedPassword: PasswordUpdateDTO): Promise<MessagingHelper<null>> {
        try {
            var response = await APIService.Axios().post(`${APIService.GetURL()}/user/UpdatePassword/${userId}`,
                {
                    ...updatedPassword
                },
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        "Authorization": "Bearer " + APIService.GetToken()
                    }
                });
            return response.data;
        } catch (error) {
            return new MessagingHelper<null>(false, "Erro ao atualizar a password", null);
        };
    }

    async UpdateUser(userId: string, updatedUser: UserUpdateDTO): Promise<MessagingHelper<null>> {
        try {
            var response = await APIService.Axios().post(`${APIService.GetURL()}/user/UpdateUser/${userId}`,
                {
                    ...updatedUser
                },
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        "Authorization": "Bearer " + APIService.GetToken()
                    }
                });
            return response.data;
        } catch (error) {
            return new MessagingHelper<null>(false, "Erro ao atualizar o utilizador", null);
        };
    }


    async ForgotPassword(email: string): Promise<MessagingHelper<null>> {
        try {
            var response = await APIService.Axios().post(`${APIService.GetURL()}/user/ForgotPassword`, { email: email });
            return response.data;
        } catch (error) {
            return new MessagingHelper<any>(false, "Erro ao enviar pedido para recuperar password", null);
        };
    }

    async ResetPassword(resetPassword: ResetPasswordDTO): Promise<MessagingHelper<null>> {
        try {
            var response = await APIService.Axios().post(`${APIService.GetURL()}/user/ResetPassword`, {
                ...resetPassword
            }, {
                withCredentials: true
            });
            return response.data;
        } catch (error) {
            return new MessagingHelper<any>(false, "Erro ao atualizar password", null);
        };
    }

    async GetPreferedViews(): Promise<MessagingHelper<string[]>> {
        try {
            var response = await APIService.Axios().get(`${APIService.GetURL()}/user/GetPreferedViews`,
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                });
            return response.data;
        } catch (error) {
            return new MessagingHelper<string[]>(false, "Erro ao obter as vistas preferidas", []);
        };
    }

    async SubmitDigitalSignature(
        id: string | undefined,
        data: DigitalSignatureDTO
      ): Promise<MessagingHelper<null>> {
        try {
          var response = await APIService.Axios().post(
            `${APIService.GetURL()}/user/DigitalSignature/${id}`,
            {
              ...data,
            },
            {
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: "Bearer " + APIService.GetToken(),
              },
            }
          );
          return response.data;
        } catch (error) {
          return new MessagingHelper<null>(
            false,
            "Ocorreu um erro ao submeter assinatura",
            null
          );
        }
      }
}